// Amenity icon mapping
export const amenityIcons: { [key: string]: string } = {
  // Common amenities
  wifi: "fa-solid fa-wifi",
  parking: "fa-solid fa-square-parking",
  "air conditioning": "fa-solid fa-snowflake",
  ac: "fa-solid fa-snowflake",
  heating: "fa-solid fa-temperature-high",
  kitchen: "fa-solid fa-kitchen-set",
  kitchenette: "fa-solid fa-utensils",
  laundry: "fa-solid fa-soap",
  washer: "fa-solid fa-shirt",
  dryer: "fa-solid fa-fire",
  tv: "fa-solid fa-tv",
  television: "fa-solid fa-tv",
  cable: "fa-solid fa-broadcast-tower",
  internet: "fa-solid fa-globe",
  pool: "fa-solid fa-person-swimming",
  "swimming pool": "fa-solid fa-person-swimming",
  gym: "fa-solid fa-dumbbell",
  fitness: "fa-solid fa-dumbbell",
  elevator: "fa-solid fa-elevator",
  lift: "fa-solid fa-elevator",
  balcony: "fa-solid fa-house-chimney",
  terrace: "fa-solid fa-house-chimney-window",
  garden: "fa-solid fa-seedling",
  backyard: "fa-solid fa-tree",
  "pet friendly": "fa-solid fa-paw",
  "pets allowed": "fa-solid fa-paw",
  security: "fa-solid fa-shield",
  Security: "fa-solid fa-shield",
  "24/7 security": "fa-solid fa-shield",
  cctv: "fa-solid fa-video",
  surveillance: "fa-solid fa-video",
  "power backup": "fa-solid fa-battery-full",
  generator: "fa-solid fa-bolt",
  water: "fa-solid fa-droplet",
  "water supply": "fa-solid fa-droplet",
  furnished: "fa-solid fa-couch",
  "semi-furnished": "fa-solid fa-couch",
  unfurnished: "fa-solid fa-box-open",
  storage: "fa-solid fa-box",
  wardrobe: "fa-solid fa-door-closed",
  closet: "fa-solid fa-door-closed",
  bathroom: "fa-solid fa-bath",
  shower: "fa-solid fa-shower",
  bathtub: "fa-solid fa-bath",
  toilet: "fa-solid fa-toilet",
  sink: "fa-solid fa-sink",
  bedroom: "fa-solid fa-bed",
  bed: "fa-solid fa-bed",
  sofa: "fa-solid fa-couch",
  "dining table": "fa-solid fa-utensils",
  refrigerator: "fa-solid fa-refrigerator",
  fridge: "fa-solid fa-refrigerator",
  microwave: "fa-solid fa-microscope",
  oven: "fa-solid fa-fire-burner",
  stove: "fa-solid fa-fire-burner",
  dishwasher: "fa-solid fa-sink",

  // Building amenities
  lobby: "fa-solid fa-door-open",
  reception: "fa-solid fa-concierge-bell",
  concierge: "fa-solid fa-concierge-bell",
  rooftop: "fa-solid fa-building",
  "rooftop terrace": "fa-solid fa-building",
  playground: "fa-solid fa-child-reaching",
  "children's play area": "fa-solid fa-child-reaching",
  "jogging track": "fa-solid fa-person-running",
  "sports court": "fa-solid fa-volleyball",
  "tennis court": "fa-solid fa-table-tennis-paddle-ball",
  "basketball court": "fa-solid fa-basketball",
  clubhouse: "fa-solid fa-building-user",
  "community hall": "fa-solid fa-users",
  "party hall": "fa-solid fa-champagne-glasses",
  "business center": "fa-solid fa-briefcase",
  "conference room": "fa-solid fa-people-group",
  spa: "fa-solid fa-spa",
  sauna: "fa-solid fa-temperature-arrow-up",
  jacuzzi: "fa-solid fa-hot-tub-person",
  "steam room": "fa-solid fa-cloud",

  // Safety and accessibility
  "fire extinguisher": "fa-solid fa-fire-extinguisher",
  "fire alarm": "fa-solid fa-bell",
  "smoke detector": "fa-solid fa-smoke",
  "first aid": "fa-solid fa-kit-medical",
  "wheelchair accessible": "fa-solid fa-wheelchair",
  ramp: "fa-solid fa-hill-avalanche",
  handrails: "fa-solid fa-hand-holding",

  // Utilities
  electricity: "fa-solid fa-plug",
  gas: "fa-solid fa-fire-flame-curved",
  solar: "fa-solid fa-solar-panel",
  "solar panels": "fa-solid fa-solar-panel",
  "rainwater harvesting": "fa-solid fa-cloud-rain",
  "waste disposal": "fa-solid fa-trash",

  // Default icon for unmapped amenities
  default: "fa-solid fa-check",
};

// Function to get icon for amenity
export const getAmenityIcon = (amenityName: string): string => {
  const normalized = amenityName.toLowerCase().trim();

  // Check for exact match first
  if (amenityIcons[normalized]) {
    return amenityIcons[normalized];
  }

  // Check for partial matches
  for (const [key, icon] of Object.entries(amenityIcons)) {
    if (
      key !== "default" &&
      (normalized.includes(key) || key.includes(normalized))
    ) {
      return icon;
    }
  }

  // Return default icon if no match found
  return amenityIcons["default"];
};
